import script from "./tournament-grid.vue?vue&type=script&setup=true&lang=js"
export * from "./tournament-grid.vue?vue&type=script&setup=true&lang=js"

import "./tournament-grid.vue?vue&type=style&index=0&id=184bc88c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-184bc88c"]])

export default __exports__